import { render, staticRenderFns } from "./xunbu.vue?vue&type=template&id=4f61f1a2&scoped=true"
import script from "./xunbu.vue?vue&type=script&lang=js"
export * from "./xunbu.vue?vue&type=script&lang=js"
import style0 from "./xunbu.vue?vue&type=style&index=0&id=4f61f1a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61f1a2",
  null
  
)

export default component.exports